import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { UserPermissionResponse } from '../interfaces/manage-user';

@Injectable({
  providedIn: 'root',
})
export class ManageUserService extends ApiService {
  public fetchManageUser(paramsObj?: any): Observable<UserPermissionResponse> {
    return this.get<UserPermissionResponse>(ROUTES.MANAGE_USER, {
      params: paramsObj,
    });
  }
  public getUserDetails(userId:number): Observable<any>{
    return this.get<any>(ROUTES.MANAGE_USER+'/'+userId);
  }
  public updatePermissions(userId:number,bodyObj?: any): Observable<any>{
    return this.patch<any>(ROUTES.MANAGE_USER+'/'+userId,{
      body: bodyObj,
    })
  }
  public updatePermissionsNew(userId:number,bodyObj?: any): Observable<any>{
    return this.patch<any>(ROUTES.MANAGE_USER_NEW+'/'+userId,{
      body: bodyObj,
    })
  }
  public getWorkerRoleList(): Observable<any>{
    return this.get<any>(ROUTES.WORKER_ROLE_LIST)
  }
  public attachNewRole(userId:number,bodyObj?: any): Observable<any>{
    return this.patch<any>(ROUTES.USER_NEW_ROLE+'/'+userId,{
      body: bodyObj,
    })
  }
  public resetUserFC(userId:number): Observable<any>{
    return this.patch<any>(ROUTES.USER_RESET_FC+'/'+userId)
  }
  public removeExistingRole(userId:number,bodyObj?: any): Observable<any>{
    return this.patch<any>(ROUTES.USER_REMOVE_ROLE+'/'+userId,{
      body: bodyObj,
    })
  }
  public fetchManageUserDetails(): Observable<any> {
    return this.get<any>(ROUTES.MANAGE_USER_DETAILS);
  }

  public fetchManagablePermissionLevels(): Observable<any> {
    return this.get<any>(ROUTES.USER_MANAGE_LEVELS);
  }

  public fetchUserRoleLocations(reqData:any): Observable<any> {
    return this.get<any>(ROUTES.USER_ROLE_LOCATIONS, {
      params: reqData,
    });
  }

  public fetchUserRolePermissions(reqData:any): Observable<any> {
    return this.get<any>(ROUTES.USER_ROLE_PERMISSIONS, {
      params: reqData,
    });
  }
}
